export const GET_VIDEO = "GET_VIDEO";
export const GET_COMMENT = "GET_COMMENT";
export const GET_LIKE = "GET_LIKE";
export const DELETE_VIDEO = "DELETE_VIDEO";
export const DELETE_COMMENT = "DELETE_COMMENT";
export const GET_FAKE_VIDEO = "GET_FAKE_VIDEO";
export const INSERT_FAKE_VIDEO = "INSERT_FAKE_VIDEO";
export const EDIT_FAKE_VIDEO = "EDIT_FAKE_VIDEO";
